var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 17.5C15.449 17.5 16.625 16.324 16.625 14.875C16.625 13.426 15.449 12.25 14 12.25C12.551 12.25 11.375 13.426 11.375 14.875C11.375 16.324 12.551 17.5 14 17.5ZM31.5 33.25H11.4818L23.7405 23.0212C24.171 22.6555 24.9515 22.6573 25.3733 23.0195L33.25 29.7395V31.5C33.25 32.466 32.466 33.25 31.5 33.25ZM10.5 8.75H31.5C32.466 8.75 33.25 9.534 33.25 10.5V25.137L27.6448 20.356C25.9123 18.8825 23.2015 18.8825 21.4848 20.3455L8.75 30.9715V10.5C8.75 9.534 9.534 8.75 10.5 8.75ZM31.5 5.25H10.5C7.6055 5.25 5.25 7.6055 5.25 10.5V31.5C5.25 34.3945 7.6055 36.75 10.5 36.75H31.5C34.3945 36.75 36.75 34.3945 36.75 31.5V10.5C36.75 7.6055 34.3945 5.25 31.5 5.25Z",
    fill: "#D7D9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.0069d79759a2c1f72f12a89bde587659.svg";
export { ForwardRef as ReactComponent };